<template>
    <slide-x-left-transition :duration="400+(index*100)" :delay="200+(index*100)">
        <ion-card v-if="show" mode="ios" style="margin: 0 0 20px 0px" :disabled="disabled">
            <ion-item>
                <ion-label mode="md" class="ion-text-wrap">
                    <ion-badge v-if="badge"><svg v-if="!disabled" class="icon icon-checkmark"><use xlink:href="#icon-checkmark"></use></svg>{{ badge }}</ion-badge>
                    <h2>{{ title }}</h2>
                    <div v-html="content"></div>
                    <h4 class="mt-10 text-right">Suma: {{ price }}&nbsp;<span style="text-transform:lowercase">zł</span></h4>
                </ion-label>
            </ion-item>
            <ion-card-content>
                <ion-row>
                    <ion-col class="text-right">
                        <ion-button mode="ios" fill="outline" size="small" @click="cancelOrder" :disabled="disabled">Anuluj</ion-button>
                        <ion-button mode="ios" fill="outline" size="small" @click="goToDetails" :disabled="disabled">Zobacz szczegóły</ion-button>
                    </ion-col>
                </ion-row>
            </ion-card-content>
        </ion-card>
    </slide-x-left-transition>
</template>

<script>
    export default {
        name: 'ItemWiki',
        props: ['index', 'slug', 'badge', 'title', 'content', 'price', 'disabled'],
        data() {
            return {
                show: false
            }
        },
        mounted() {
            this.show = true;
        },
        methods: {
            cancelOrder(e){
                e.preventDefault();
                this.$ionic.alertController
                    .create({
                        header: 'Potwierdź',
                        message: 'Czy na pewno chcesz anulować to zamówienie?',
                        buttons: [
                            {
                                text: 'Anuluj',
                                role: 'cancel',
                            },
                            {
                                text: 'Tak',
                                handler: () => {
                                    return this.$store.dispatch('GLOBAL_TOAST','Anulowano poprawnie.');
                                }
                            }
                        ],
                        mode: 'md'
                    })
                    .then(a => a.present())
            },
            goToDetails(e){
                console.log('goToDetails')
            }
        }
    }
</script>

<style lang="scss" scoped>
    ion-card-content{
        padding: 6px;
    }
</style>